import { createElement, forwardRef } from 'react'
import { mergeCss } from '../css/css.mjs';
import { splitProps } from '../helpers.mjs';
import { getStarRatingRootStyle } from '../patterns/star-rating-root.mjs';
import { styled } from './factory.mjs';

export const StarRatingRoot = /* @__PURE__ */ forwardRef(function StarRatingRoot(props, ref) {
  const [patternProps, restProps] = splitProps(props, ["size","gap","color"])

const styleProps = getStarRatingRootStyle(patternProps)
const cssProps = { css: mergeCss(styleProps, props.css) }
const mergedProps = { ref, ...restProps, ...cssProps }

return createElement(styled.span, mergedProps)
  })